import apiClient from "../config/api";

/**
 * Get all non-admin users
 * @returns {Promise} API response with users data
 */
export const getUsers = async () => {
  try {
    const response = await apiClient.get("/users");
    return response.data;
  } catch (error) {
    console.error("getUsers error:", error);
    throw error;
  }
};

/**
 * Get user by ID
 * @param {string} userId - User ID
 * @returns {Promise} API response with user data
 */
export const getUserById = async (userId) => {
  try {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error("getUserById error:", error);
    throw error;
  }
};

/**
 * Suspend user
 * @param {string} userId - User ID
 * @param {Object} suspendData - Suspension data
 * @param {number} suspendData.duration - Duration in days (must be a number)
 * @param {string} suspendData.reason - Reason for suspension
 * @returns {Promise} API response
 */
export const suspendUser = async (userId, suspendData) => {
  try {
    // Ensure duration is a number
    const payload = {
      duration: Number(suspendData.duration),
      reason: suspendData.reason || "",
    };
    
    const response = await apiClient.put(`/suspend-user/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("suspendUser error:", error);
    throw error;
  }
};

/**
 * Revoke user verification
 * @param {string} userId - User ID
 * @param {Object} revokeData - Revoke data
 * @param {string} revokeData.subject - Subject for revocation
 * @param {string} revokeData.message - Message for revocation
 * @returns {Promise} API response
 */
export const revokeVerification = async (userId, revokeData) => {
  try {
    const payload = {
      subject: revokeData.subject || "",
      message: revokeData.message || "",
    };
    
    const response = await apiClient.put(`/revoke-verification/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("revokeVerification error:", error);
    throw error;
  }
};

/**
 * Restore user access
 * @param {string} userId - User ID
 * @param {Object} restoreData - Restore data
 * @param {string} restoreData.message - Message for restoration
 * @returns {Promise} API response
 */
export const restoreAccess = async (userId, restoreData) => {
  try {
    const payload = {
      message: restoreData.message || "",
    };
    
    const response = await apiClient.put(`/restore-access/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("restoreAccess error:", error);
    throw error;
  }
};

/**
 * Approve business application
 * @param {string} userId - User ID
 * @returns {Promise} API response
 */
export const approveApplication = async (userId) => {
  try {
    const response = await apiClient.put(`/approve-application/${userId}`);
    return response.data;
  } catch (error) {
    console.error("approveApplication error:", error);
    throw error;
  }
};

/**
 * Delete user
 * @param {string} userId - User ID
 * @returns {Promise} API response
 */
export const deleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error("deleteUser error:", error);
    throw error;
  }
};
